module.exports = __webpack_public_path__ + "files/fb1e051dff8629a672699a91175f9b8f.png";